import React, { useState } from 'react';
import {
  ScFlexColCenter,
  ScMaxWidthContainer,
  ScMaxWidthContainerWide,
  ScSeparator,
} from './../components/styled-components';

import Furnishing from '../subpages/furnishing';
import Image from '../components/image';
import Introduction from '../subpages/introduction';
import LandingArea from '../subpages/landingarea';
import Layout from '../components/layout';
import Map from '../subpages/map';
import Prices from '../subpages/prices';
import SEO from '../components/seo';
import globals from '../utils/variables';
import styled from 'styled-components';

const ScPersonImage = styled.div`
  height: 22rem;
  width: 30rem;
  max-width: 80vw;
  margin: 1rem;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  overflow: hidden;
`;

const ScColumns = styled.div`
  @media only screen and (min-width: 1024px) {
    display: flex;
  }
`;

let accepted = false;
if (typeof document !== `undefined`) {
  accepted = document.cookie.indexOf('gatsby-gdpr=true') !== -1;
}

const IndexPage = () => {
  const [cookieAccepted, setCookieAccepted] = useState(!!accepted);
  return (
    <Layout onCookieAccept={() => setCookieAccepted(true)}>
      <SEO title="Ferienwohnung F&M Rath" keywords={globals.keywords} />
      <LandingArea />
      <ScMaxWidthContainer>
        <Introduction />
      </ScMaxWidthContainer>
      <ScSeparator />
      <ScMaxWidthContainer>
        <Furnishing />
      </ScMaxWidthContainer>
      <ScSeparator />
      <ScMaxWidthContainer>
        <Prices />
      </ScMaxWidthContainer>
      <ScSeparator />
      <ScMaxWidthContainer>
        <Map cookieAccepted={cookieAccepted} />
      </ScMaxWidthContainer>
    </Layout>
  );
};

export default IndexPage;
